import { InputMask } from '@react-input/mask';
import TextArea from 'antd/es/input/TextArea';
import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import Select, { StylesConfig } from "react-select";
import { toast } from "react-toastify";
import * as Yup from "yup";
import TextField from '../../../../core/common/textFields/TextField';
import { removeImage, setImage } from '../../../../Features/commonSlice';
import { useCreateContactMutation, useGetContactLookupQuery, useUpdateContactMutation } from "../../../../services/EndPointsApis";
import { RootState } from '../../../../store';
import { svgIcons } from '../../../../style/fonts/SvgIcons';



const LeadContactsSidebar = ({ activityTogglePopup, closeSidebar, isEditing, viewOnly, contactData, refetchContacts }: any) => {
    const dispatch = useDispatch();
    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };
    const [updateId, setUpdateId] = useState(0);
    const imageUrl = useSelector((state: RootState) => state.common?.imageUrl);
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    const contactSchema = Yup.object().shape({
        contactTypeId: Yup.object({
            id: Yup.number()
                .min(1, 'Contact Status must be selected'),
            name: Yup.string().required('Contact Type is required')
        }),
        contactStatus: Yup.object({
            id: Yup.number()
                .min(1, 'Contact Status must be selected'),
            name: Yup.string().required('Contact Status title is required')
        }),
        firstName: Yup.string()
            .required("First Name is required"),
        salutationId: Yup.object({
            id: Yup.number()
                .min(1, 'Salutation Id must be selected'),
            name: Yup.string().required('Salutation Id title is required')
        }),
        lastName: Yup.string()
            .required("Last Name is required"),
    });
    const initialValues = {
        contactTypeId: {
            id: 0,
            name: "string"
        },
        contactStatus: {
            id: 0,
            name: "string"
        },
        companyName: "",
        salutationId: {
            id: 0,
            name: "string"
        },
        firstName: "",
        lastName: "",
        addressAs: "",
        martialStatusId: '',
        homePhone: "",
        workPhone: "",
        cellPhone: "",
        fax: "",
        homeEmail: "",
        workEmail: "",
        preferredMethodId: '',
        prefferedTime: "",
        isSubNewsLetter: true,
        addressLine1: "",
        addressLine2: "",
        city: '',
        state: '',
        zipcode: "",
        inquiryMethod: {
            id: 0,
            name: "string"
        },
        leadSourceId: '',
        sourceDescription: "",
    };
    const [createContact, { data, isError, error, isSuccess, isLoading }] =
        useCreateContactMutation();
    const [UpdateContact, { data: updatedata, isError: updateIsError, error: updateError, isSuccess: updateIsSuccess, }] =
        useUpdateContactMutation();
    const { data: getContactLookup, refetch } = useGetContactLookupQuery('');

    const formik = useFormik({
        validationSchema: contactSchema,
        initialValues,
        onSubmit: (values) => {
            if (isEditing) {
                UpdateContact({ ...values })
            } else {
                createContact({ ...values });
            }
        },
    });
    const { resetForm } = formik;

    useEffect(() => {
        refetch();

    }, [])
    useEffect(() => {
        if (!contactData) {
            resetForm()
        }

    }, [closeSidebar])

    useEffect(() => {
        if (contactData && Object.keys(contactData).length > 0) {
            setUpdateId(contactData?.contactId);
            formik.setValues({ ...contactData });
        } else {
            // resetForm();
        }
    }, [contactData, updateId]);

    const handleContactType = (selectedOption: any) => {
        formik.setFieldValue(' inquiryMethod', selectedOption);
    };
    const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            const imageUrl = URL.createObjectURL(file);
            dispatch(setImage(imageUrl));
            formik.setFieldValue('imageUrl', imageUrl);
            formik.setFieldValue('file', file);
        }
    };
    const handleRemoveImage = () => {
        dispatch(removeImage());
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };
    useEffect(() => {
        if (isSuccess) {
            toast.success(data?.message);
            closeSidebar();
            resetForm();
            refetchContacts()
        }
        if (updateIsSuccess) {
            toast.success(updatedata?.message);
            closeSidebar();
            refetchContacts()
        }

    }, [isSuccess, updateIsSuccess]);

    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
                errorMessage = (error.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
    }, [isError, error]);

    useEffect(() => {
        if (!activityTogglePopup && !isEditing && !contactData) {
            resetForm();
        }
    }, [activityTogglePopup]);

    return (
        <div className={activityTogglePopup ? "toggle-popup sidebar-popup" : "toggle-popup"}>
            <div className="sidebar-layout">
                <div className="sidebar-header">
                    <h4>
                        {isEditing ? "Edit Contact" : viewOnly ? 'View Contact' : 'Add Contact'}
                    </h4> <Link to="#" className="sidebar-close toggle-btn" onClick={closeSidebar}>
                        <i className="ti ti-x" />
                    </Link>
                </div>
                <div className="toggle-body">
                    <div className="pro-create">
                        <form onSubmit={formik.handleSubmit} >
                            <div className="accordion-lists" id="list-accords">
                                <div className="user-accordion-item">
                                    <Link
                                        to="#"
                                        className="accordion-wrap"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#edit-basic"
                                    >
                                        {/* <span>
                                            <i className="ti ti-user-plus" />
                                        </span> */}
                                        Contact Person
                                    </Link>
                                    <div
                                        className="accordion-collapse collapse show"
                                        id="edit-basic"
                                        data-bs-parent="#list-accords"
                                    >
                                        <div className="content-collapse">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="profile-pic-upload">
                                                        <div className="profile-pic">
                                                            <span className="position-absolute top-0 start-100 translate-middle pointer" onClick={handleRemoveImage}>
                                                                {svgIcons.DeleteIcon}
                                                            </span>
                                                            <img
                                                                src={imageUrl || '/assets/img/profiles/profile-img.jpg'}
                                                                alt="img"
                                                                className="preview1"
                                                            />
                                                        </div>
                                                        <div className="upload-content">
                                                            <div className="upload-btn">
                                                                <input
                                                                    type="file"
                                                                    accept=".png, .jpg, .jpeg"
                                                                    onChange={handleImageChange}
                                                                    ref={fileInputRef}
                                                                />
                                                                <span>
                                                                    <i className="ti ti-upload" />
                                                                    Upload Image
                                                                </span>
                                                            </div>
                                                            <p>JPG, GIF or PNG. Max size of 800K</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <label className="input-label">
                                                            Contact Type{" "} <span className="text-danger">*</span>
                                                        </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={getContactLookup?.result?.contactTypes?.map((option: any) => ({
                                                                label: option?.name,
                                                                value: option?.id
                                                            }))}
                                                            value={
                                                                formik.values?.contactTypeId?.id
                                                                    ? {
                                                                        value: formik.values?.contactTypeId?.id,
                                                                        label: formik.values?.contactTypeId?.name || '',
                                                                    }
                                                                    : null
                                                            }
                                                            isDisabled={viewOnly}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('contactTypeId.id', selectedOption.value);
                                                                formik.setFieldValue('contactTypeId.name', selectedOption.label);

                                                            }}
                                                        />
                                                    </div>
                                                    {formik.touched.contactTypeId && formik.errors.contactTypeId && (
                                                        <div className="error">{formik.errors.contactTypeId?.id}</div>
                                                    )}
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <label className="input-label">
                                                            Contact Status{" "} <span className="text-danger">*</span>
                                                        </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={getContactLookup?.result?.contactStatusTypes?.map((option: any) => ({
                                                                label: option?.name,
                                                                value: option?.id
                                                            }))}
                                                            value={
                                                                formik.values?.contactStatus?.id
                                                                    ? {
                                                                        value: formik.values?.contactStatus?.id,
                                                                        label: formik.values?.contactStatus?.name || '',
                                                                    }
                                                                    : null
                                                            }
                                                            isDisabled={viewOnly}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('contactStatus.id', selectedOption.value);
                                                                formik.setFieldValue('contactStatus.name', selectedOption.label);
                                                            }}
                                                        />
                                                    </div>
                                                    {formik.touched.contactStatus && formik.errors.contactStatus && (
                                                        <div className="error">{formik.errors.contactStatus?.id}</div>
                                                    )}
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="Company Name"
                                                            type="text"
                                                            {...formik.getFieldProps("companyName")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <label className="input-label">
                                                            Salutation{" "} <span className="text-danger">*</span>
                                                        </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={getContactLookup?.result?.salutationTypes?.map((option: any) => ({
                                                                label: option?.name,
                                                                value: option?.id
                                                            }))}
                                                            value={
                                                                formik.values?.salutationId?.id
                                                                    ? {
                                                                        value: formik.values?.salutationId?.id,
                                                                        label: formik.values?.salutationId?.name || '',
                                                                    }
                                                                    : null
                                                            }
                                                            isDisabled={viewOnly}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('salutationId.id', selectedOption.value);
                                                                formik.setFieldValue('salutationId.name', selectedOption.label);

                                                            }}
                                                        />
                                                    </div>
                                                    {formik.touched.salutationId?.id && formik.errors.salutationId?.id && (
                                                        <div className="error">{formik.errors.salutationId?.id}</div>
                                                    )}
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label=" First Name"
                                                            type="text"
                                                            required
                                                            {...formik.getFieldProps("firstName")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                    {formik.touched.firstName && formik.errors.firstName && (
                                                        <div className="error">{formik.errors.firstName}</div>
                                                    )}
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="Last Name"
                                                            type="text"
                                                            required
                                                            {...formik.getFieldProps("lastName")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                    {formik.touched.lastName && formik.errors.lastName && (
                                                        <div className="error">{formik.errors.lastName}</div>
                                                    )}
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="Address As"
                                                            type="text"
                                                            {...formik.getFieldProps("addressAs")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <label className="input-label">Marital Status</label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={getContactLookup?.result?.maritalStatusTypes?.map((option: any) => ({
                                                                label: option?.name,
                                                                value: option?.id
                                                            }))}
                                                            isDisabled={viewOnly}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('martialStatusId', selectedOption);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="user-accordion-item">
                                    <Link
                                        to="#"
                                        className="accordion-wrap collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#edit-address"
                                    >
                                        {/* <span>
                                            <i className="ti ti-map-pin-cog" />
                                        </span> */}
                                        Contact Info
                                    </Link>
                                    <div
                                        className="accordion-collapse collapse"
                                        id="edit-address"
                                        data-bs-parent="#list-accords"
                                    >
                                        <div className="content-collapse">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <label className='input-label'>
                                                            Home Phone
                                                        </label>
                                                        <InputMask mask=" +1(___)___-____"
                                                            replacement={{ _: /\d/ }}
                                                            className="form-control"
                                                            {...formik.getFieldProps("homePhone")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <label className='input-label'>
                                                            Work Phone
                                                        </label>
                                                        <InputMask mask=" +1(___)___-____"
                                                            replacement={{ _: /\d/ }}
                                                            className="form-control"
                                                            {...formik.getFieldProps("workPhone")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <label className='input-label'>
                                                            Cell Phone
                                                        </label>
                                                        <InputMask mask=" +1(___)___-____"
                                                            replacement={{ _: /\d/ }}
                                                            className="form-control"
                                                            {...formik.getFieldProps("cellPhone")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">

                                                        <TextField
                                                            label='fax'
                                                            type='text'
                                                            className="form-control"
                                                            {...formik.getFieldProps("fax")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="Home Email"
                                                            type="email"
                                                            {...formik.getFieldProps("homeEmail")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="Work Email "
                                                            type="email"
                                                            {...formik.getFieldProps("workEmail")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <label className="input-label">Preferred Method
                                                            {/* <span className="text-danger">*</span> */}
                                                        </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={getContactLookup?.result?.preferredMethodTypes?.map((option: any) => ({
                                                                label: option?.name,
                                                                value: option?.id
                                                            }))}
                                                            isDisabled={viewOnly}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('preferredMethodId', selectedOption);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="Preferred Times "
                                                            type="text"
                                                            {...formik.getFieldProps("prefferedTime")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="input-label">
                                                        Unsubscribe from Newsletter?<span className="text-danger"> *</span>
                                                    </label>
                                                    <label className="checkboxs mt-2 mb-5">
                                                        <input
                                                            type="checkbox"
                                                            defaultChecked
                                                            disabled={viewOnly}
                                                            {...formik.getFieldProps("isSubNewsLetter")}
                                                        />
                                                        <span className="checkmarks" />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="user-accordion-item">
                                    <Link
                                        to="#"
                                        className="accordion-wrap collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#mailing-address"
                                    >
                                        {/* <span>
                                            <i className="ti ti-map-pin-cog" />
                                        </span> */}
                                        Mailing Address
                                    </Link>
                                    <div
                                        className="accordion-collapse collapse"
                                        id="mailing-address"
                                        data-bs-parent="#list-accords"
                                    >
                                        <div className="content-collapse">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="Address Line 1"
                                                            type="text"
                                                            {...formik.getFieldProps("addressLine1")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="Address Line 2 "
                                                            type="text"
                                                            {...formik.getFieldProps("addressLine2")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="City "
                                                            type="text"
                                                            {...formik.getFieldProps("city")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="State/Region "
                                                            type="text"
                                                            {...formik.getFieldProps("state")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <TextField
                                                            label="ZipCode "
                                                            type="text"
                                                            {...formik.getFieldProps("zipcode")}
                                                            disabled={viewOnly}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="user-accordion-item">
                                    <Link
                                        to="#"
                                        className="accordion-wrap collapsed"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#contact-source"
                                    >
                                        {/* <span>
                                            <i className="ti ti-map-pin-cog" />
                                        </span> */}
                                        Contact Source Info
                                    </Link>
                                    <div
                                        className="accordion-collapse collapse"
                                        id="contact-source"
                                        data-bs-parent="#list-accords"
                                    >
                                        <div className="content-collapse">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <label className="input-label">Inquiry Method
                                                            {/* <span className="text-danger">*</span> */}
                                                        </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={getContactLookup?.result?.inquiryMethodTypes?.map((option: any) => ({
                                                                label: option?.name,
                                                                value: option?.id
                                                            }))}
                                                            isDisabled={viewOnly}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('inquiryMethod', selectedOption);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-wrap">
                                                        <label className="input-label">Lead Source </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={getContactLookup?.result?.leadSourceTypes?.map((option: any) => ({
                                                                label: option?.name,
                                                                value: option?.id
                                                            }))}
                                                            isDisabled={viewOnly}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue('leadSourceId', selectedOption);
                                                            }}

                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="form-wrap">
                                                        <label className="input-label ">Source Description
                                                            {/* <span className="text-danger">*</span> */}
                                                        </label>
                                                        <TextArea
                                                            className="form-control height-150"
                                                            defaultValue="21213"
                                                            disabled={viewOnly}
                                                            {...formik.getFieldProps("sourceDescription")}

                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="submit-button text-end">
                                <Link to="#" className="btn btn-light sidebar-close" onClick={closeSidebar}>
                                    Cancel
                                </Link>
                                {!viewOnly ? (
                                    <button type="submit" className="btn btn-primary">
                                        {isEditing ? "Update" : 'Add'}
                                    </button>
                                ) : (
                                    <>
                                    </>
                                )
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LeadContactsSidebar;
